import { AuthRepository } from "../../api";
import { Auth } from "../../models/lib/entities/Auth";

export class AppController {
	constructor(context) {
		this.authRepo = new AuthRepository();
	}
}



// WEBPACK FOOTER //
// src/controllers/lib/AppController.js